export const navigation_broker = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  }, 
  {
    text: 'InTray',
    path: '/in-tray',
    icon: 'message'
  },
  {
    text: 'Scheme Details',
    path: '/reports',
    icon: 'doc'
  }, 
  {
    text: 'Get a Quote',
    path: '/quotations',
    icon: 'edit'
  },
  {
    text: 'Members',
    path: '/members',
    icon: 'group'
  },
  {
    text: 'Claims',
    path: '/claims',
    icon: 'card'
  },
  // {
  //   text: 'Commissions',
  //   path: '/commissions',
  //   icon: 'money'
  // },
  // {
  //   text: 'Write to Britam',
  //   path: '/enquiries',
  //   icon: 'message'
  // },
  // {
  //   text: 'FAQ',
  //   path: '/faq',
  //   icon: 'help'
  // },
  {
    text: 'Profile',
    path: '/profile',
    icon: 'user'
  }
];